import type { CncQuoteFields, RfqSubmission, TimberSupplierStructureRef } from '../types';
import { normalizeQuotedStructures } from './timberQuoteStreamKey';
import { isValidQuoteTotal } from './rfqQuoteTotal';
import { stampPmQuoteInputAdjustment, type PmQuoteInputActor } from './rfqPmQuoteInputStamp';

export type CncQuoteSubmissionEdits = {
  quoteTotal?: number;
  cncQuote?: Partial<CncQuoteFields>;
  /** Empty array clears explicit scope (falls back to assigned / full-scope display). */
  quotedStructures?: TimberSupplierStructureRef[];
};

export async function updateCncQuoteSubmission(
  updateRfqSubmission: (id: string, updates: Partial<RfqSubmission>) => Promise<void>,
  sub: RfqSubmission,
  edits: CncQuoteSubmissionEdits,
  actor: PmQuoteInputActor,
): Promise<void> {
  if (!sub.id) return;
  const updates: Partial<RfqSubmission> = {};

  if (edits.quoteTotal != null) {
    if (!isValidQuoteTotal(edits.quoteTotal)) {
      throw new Error('Enter a valid quote amount.');
    }
    updates.quoteTotal = edits.quoteTotal;
  }

  if (edits.cncQuote && sub.cncQuote) {
    updates.cncQuote = { ...sub.cncQuote, ...edits.cncQuote };
  } else if (edits.cncQuote) {
    updates.cncQuote = edits.cncQuote as CncQuoteFields;
  }

  if (edits.quotedStructures !== undefined) {
    updates.quotedStructures = edits.quotedStructures.length
      ? normalizeQuotedStructures(edits.quotedStructures)
      : undefined;
  }

  if (!Object.keys(updates).length) return;

  await updateRfqSubmission(sub.id, {
    ...updates,
    ...stampPmQuoteInputAdjustment(actor),
  });
}
